export const isFullStatic = false
export const staticPath = "/Users/gayansandamal/Documents/Code projects/findyo/findyo-web-clients/admin-portal-revamp/.nuxt/static-json"
export const publicPath = "/"
export const globalContext = "__NUXT__"
export const globalNuxt = "$nuxt"